import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SkeletonItem as SkelItem } from '@atlaskit/menu';
import { ITEM_SIDE_PADDING } from '../../common/styles';
import { useShouldNestedElementRender } from '../NestableNavigationContent/context';

var SkeletonItem = function SkeletonItem(props) {
  var _useShouldNestedEleme = useShouldNestedElementRender(),
      shouldRender = _useShouldNestedEleme.shouldRender;

  if (!shouldRender) {
    return null;
  }

  return /*#__PURE__*/React.createElement(SkelItem, _extends({
    cssFn: function cssFn() {
      return {
        paddingLeft: ITEM_SIDE_PADDING,
        paddingRight: ITEM_SIDE_PADDING,
        '&&::before': {
          // This doubles up & to get a higher specificity as well as to not overwite the base styles.
          marginRight: 18
        }
      };
    }
  }, props));
};

export default SkeletonItem;